var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBritishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 341.59 203.057",
    viewBox: "0 0 341.59 203.057",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.063 0h341.47v202.17h-341.47z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.063,12",
    fill: "#ffffbd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.323 49.445",
    fill: "#f00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m.063,20v56.5h96z",
    fill: "#13135f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m109.91 76.5h19.652l-129.5-76.5v12z",
    fill: "#f00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.916 0 109.65 67.486v-67.486z",
    fill: "#12145b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m341.56 182v-56h-95z",
    fill: "#13135f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m232.72 126h-19.652l128.5 76.125v-12.125z",
    fill: "#f00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m304.68 203-109.65-67.486v67.486z",
    fill: "#12145b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m341.56 20.513v55.987l-95-0.068z",
    fill: "#13135f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m195.06 76.5h22.298l124.2-76.5h-22.554z",
    fill: "#f00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m303.75 0-108.69 66.986v-66.986z",
    fill: "#12145b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m0.071 182.48v-56.5h96z",
    fill: "#13135f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m147.52 125.97h-22.299l-125.22 77.088h22.572z",
    fill: "#f00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m37.87 202.97 109.65-67.486v67.486z",
    fill: "#12145b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m156.72 0h28.874v203h-28.874z",
    fill: "#f00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m0.063 85.252h341.53v32.672h-341.53z",
    fill: "#f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritishFlag);
export default __webpack_public_path__ + "static/media/british-flag.bfb47278fddd73d31c15a74c2daa333d.svg";
export { ForwardRef as ReactComponent };